module.exports = __webpack_public_path__ + "img/cc5f3a8.jpg";